/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useRef } from "react";
import { useIntl } from "react-intl";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { remoteImageStaticUrl } from "common/utils/remote-image";
import StoreCreditTiers from "common/vue/components/StoreCreditTiers.react.vue";
import Tooltip from "common/vue/components/Tooltip.react.vue";
import useTransfersStoreCredit from "common/vue/composables/useTransfersStoreCredit.react";
import "./TransfersStoreCredit.scss";

/* TODO(vue-migration): convert useI18n from intl/useI18n.vue - verify react-intl API compatibility */

export default function TransfersStoreCredit({ storeCreditInfo, ...restProps }: any) {
  const intl = useIntl();
  const containerRef = useRef(null);

  const {
    creditAmount,
    currentExpectedCredits,
    tiers,
    currentTier,
    totalCartAmount,
    orderSubtotal,
    expectedCredits,
    updateStoreCreditInfo
  } = useTransfersStoreCredit();

  updateStoreCreditInfo(storeCreditInfo);

  function toggleTooltip() {
    submitDtfEvent("transfer_store_credit_info_icon_clicked", {
      credits: currentExpectedCredits.value,
      order_subtotal: orderSubtotal,
      expected_credits: expectedCredits,
      current_tier: currentTier.value?.range,
      credit_amount: creditAmount.value
    });
  }

  const loyaltyBadgeUrl = remoteImageStaticUrl("gen/loyalty-badge.png");

  return (
    <>
      {totalCartAmount.value > 0 ? (
        <div
          {...restProps}
          className={cn("transfers-store-credit scope-0fc8e48f", restProps?.className)}
          ref={containerRef}
        >
          <img
            className={cn("transfers-store-credit__icon scope-0fc8e48f")}
            alt="Loyalty Badge"
            src={loyaltyBadgeUrl}
          />

          <div className={cn("transfers-store-credit__content scope-0fc8e48f")}>
            <div className={cn("transfers-store-credit__text scope-0fc8e48f")}>
              {currentExpectedCredits.value > 0 ? (
                <span className={cn("scope-0fc8e48f")}>
                  {" "}
                  You'll earn{" "}
                  <strong className={cn("scope-0fc8e48f")}>
                    {intl.formatNumber(currentExpectedCredits.value, { style: "currency" })}
                  </strong>{" "}
                  credit on Transfers!{" "}
                </span>
              ) : (
                <span className={cn("scope-0fc8e48f")}>Earn credits on Transfers!</span>
              )}
              <Tooltip
                className={cn("scope-0fc8e48f")}
                trigger="click"
                position="bottom-right"
                onShow={toggleTooltip}
                slots={{
                  target: () => (
                    <UseSvg
                      className={cn("transfers-store-credit__info-icon scope-0fc8e48f")}
                      icon="info-circle-bold"
                      data-testid="transfers-store-credit-info-icon"
                    />
                  ),

                  content: () => (
                    <StoreCreditTiers
                      className={cn("scope-0fc8e48f")}
                      currentTier={currentTier.value}
                      tiers={tiers.value}
                      totalAmount={totalCartAmount.value}
                      isTooltip={true}
                      data-testid="store-credit-tiers"
                    />
                  )
                }}
                data-testid="tooltip"
              />
            </div>
            {creditAmount.value > 0 ? (
              <div className={cn("transfers-store-credit__store-credit scope-0fc8e48f")}>
                <span className={cn("transfers-store-credit__store-credit-label scope-0fc8e48f")}>
                  Transfers Credit Balance:
                </span>
                <span className={cn("transfers-store-credit__store-credit-amount scope-0fc8e48f")}>
                  {intl.formatNumber(creditAmount.value, { style: "currency" })}
                </span>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  );
}

TransfersStoreCredit.displayName = "TransfersStoreCredit";
